import Vue from 'vue'
import App from './App.vue'
import Keycloak from "keycloak-js";
import router from "./router";
import VueLogger from 'vuejs-logger';
import vuetify from './plugins/vuetify'
import Api from "@/api/api";
import CompanyApi from "@/api/companyApi";
import LicenseApi from "@/api/licenseApi";
import CertificateApi from "@/api/certificateApi";
import UserApi from "@/api/userApi";

import VueMoment from "vue-moment";
import moment from 'moment-timezone'
import DownloadApi from "@/api/downloadApi";
import CourseApi from "@/api/courseApi";
import CoursePackageApi from "@/api/coursePackageApi";
import CourseRunApi from "@/api/courseRunApi";
import ValidationApi from "@/api/validationApi";
import PdfStorageApi from "@/api/pdfStorageApi";
import LiveCourseApi from "@/api/liveCourseApi";
import VueCountdown from '@chenfengyuan/vue-countdown';
import LogApi from "@/api/logApi";

const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueMoment, {
  moment,
})
Vue.use(VueLogger, options);
import VueDragResize from 'vue-drag-resize'
import BuyCourseApi from "@/api/buyCourseApi";

Vue.component(`${VueCountdown.name}`, VueCountdown);
Vue.component('vue-drag-resize', VueDragResize)

let initOptions = {
    url: 'https://lms.behrendtonline.com/auth',
    realm: 'behrendt',
    clientId: 'behrendt-develop',
    onLoad: 'login-required'
}

let keycloak = Keycloak(initOptions);
const api = new Api(keycloak);

Vue.prototype.$keycloak = keycloak;
Vue.prototype.$http = api;
Vue.prototype.$httpLicenseApi = new LicenseApi(api);
Vue.prototype.$httpUserApi = new UserApi(api);
Vue.prototype.$httpCompanyApi = new CompanyApi(api, Vue.prototype.$httpUserApi);
Vue.prototype.$httpDownloadApi = new DownloadApi(api);
Vue.prototype.$httpCertificateApi = new CertificateApi(api);
Vue.prototype.$httpCourseApi = new CourseApi(api);
Vue.prototype.$httpCoursePackageApi = new CoursePackageApi(api);
Vue.prototype.$httpPdfStorageApi = new PdfStorageApi(api);
Vue.prototype.$httpValidationApi = new ValidationApi(api);
Vue.prototype.$httpCourseRunApi = new CourseRunApi(api);
Vue.prototype.$httpLiveCourseApi = new LiveCourseApi(api);
Vue.prototype.$httpBuyCourseApi = new BuyCourseApi(api);
Vue.prototype.$httpLogApi = new LogApi(api);

router.beforeEach((to, from, next) => {
    if (to.meta.isAuthenticated) {
        // Get the actual url of the app, it's needed for Keycloak
        if (!keycloak.authenticated) {
            // The page is protected and the user is not authenticated. Force a login.
            if (window.location.origin.includes("localhost")) {
                keycloak.login({redirectUri: "http://localhost:8081/#" + to.path})
            } else {
                keycloak.login({redirectUri: "https://lms.behrendtonline.com/#" + to.path})
            }
        } else {
            // The user was authenticated, and has the app role

            keycloak.updateToken(70)
                .then(() => {
                    next()
                })
                .catch(err => {
                    console.log("error here")
                    console.error(err)
                })
        }
    } else {
        // This page did not require authentication
        next()
    }
})


keycloak.init({checkLoginIframe: false}).then(() => {
    new Vue({
        created() {
        },
        router: router,
        el: '#app',
        vuetify,
        render: h => h(App, {props: {keycloak: keycloak}})
    })

    setInterval(() => {
        keycloak.updateToken(70).then((refreshed) => {
            if (refreshed) {
                console.log('Token refreshed' + refreshed);
            } else {
                console.log('Token not refreshed, valid for '
                    + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
            }
        }).catch(() => {
            console.log('Failed to refresh token');
            if (this === undefined || this.$route === undefined) return
            if (this.$route !== null && this.$route.name !== "Validation" && this.$route.name !== "Home" && this.$route.name !== "PublicCourseList") {
                keycloak.logout();
            }
        });
    }, 50000);
}).catch((error) => {
    console.log("Authenticated Failed", error);
});
